import { format } from 'date-fns';
import { BulkOrdering } from 'src/shared/types/bulkOrdering';
import { Timeline } from 'src/shared/types/timeline';

function getDeliveredDate(order: BulkOrdering): string {
  if (order.stage?.includes('rejected')) {
    return 'Cancelled';
  }

  const delivered = order?.timeline?.findLast(
    (value: Timeline) => value?.stage === 'delivered'
  );

  if (delivered && delivered?.finished_at) {
    return format(delivered?.finished_at, 'MMM dd, yyyy');
  }

  if (delivered && delivered?.estimated_finished_at) {
    return format(delivered?.estimated_finished_at, 'MMM dd, yyyy');
  }

  if (order.estimated_end_date) {
    return format(order.estimated_end_date, 'MMM dd, yyyy');
  }

  return '-';
}

export default getDeliveredDate;
